import './styles.scss';

import { ForwardedRef, ReactElement, forwardRef } from 'react';

import { ProgressBar as BootstrapProgressBar } from 'react-bootstrap';
import { ProgressBarTypes } from './types';
import { getClasses } from '@/utils';

const ProgressBar = forwardRef<ProgressBarTypes.RefType, ProgressBarTypes.Props>(
  (props: ProgressBarTypes.Props, ref: ForwardedRef<ProgressBarTypes.RefType>): ReactElement => {
    return <BootstrapProgressBar {...(props as any)} className={getClasses('ProgressBar', 'Common', props?.className)} ref={ref} />;
  }
);
ProgressBar.displayName = 'ProgressBar';

export default ProgressBar;
